export const renderIconTextEventHeader = (icon: React.ReactNode, text?: string) =>
  !!text && (
    <p className='text-primary inline-flex items-center gap-0.5'>
      {icon}
      <span className='text-subtitle-s line-clamp-1'>{text}</span>
    </p>
  );
